import fundingAnimationImage from '../images/Funding_AnimationPhone.png'

export default {
  v: '5.6.5',
  fr: 60,
  ip: 0,
  op: 80,
  w: 300,
  h: 240,
  nm: 'BankLinking-01',
  ddd: 0,
  assets: [{ id: 'image_0', w: 2222, h: 3883, u: '', p: fundingAnimationImage, e: 0 }],
  layers: [
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'RoundUps',
      sr: 1,
      ks: {
        p: {
          s: true,
          x: { a: 0, k: 148.938 },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.133], y: [1.075] },
                o: { x: [0.333], y: [0] },
                t: 5,
                s: [75.831],
                e: [25.331],
              },
              {
                i: { x: [0.635], y: [1] },
                o: { x: [0.475], y: [3.011] },
                t: 35,
                s: [25.331],
                e: [25.331],
              },
              { t: 62 },
            ],
          },
        },
        a: { a: 0, k: [446.677, 175.796, 0] },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.333, 0.333, 0.667], y: [1.128, 1.128, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 5,
              s: [0, 0, 100],
              e: [37.64, 37.64, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.365, 0.365, 0.333], y: [-1.209, -1.209, 0] },
              t: 35,
              s: [37.64, 37.64, 100],
              e: [37.64, 37.64, 100],
            },
            { t: 48 },
          ],
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, 33.14],
                    [0, 49.646],
                  ],
                  c: false,
                },
              },
              nm: 'Path 5',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-12.404, 29.419],
                    [-12.404, 45.924],
                  ],
                  c: false,
                },
              },
              nm: 'Path 4',
              hd: false,
            },
            {
              ind: 2,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [12.404, 29.419],
                    [12.404, 45.924],
                  ],
                  c: false,
                },
              },
              nm: 'Path 3',
              hd: false,
            },
            {
              ind: 3,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [0, -10.61],
                    [0, 10.769],
                  ],
                  c: false,
                },
              },
              nm: 'Path 2',
              hd: false,
            },
            {
              ind: 4,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [2.166, 0],
                    [0, -3.792],
                    [-3.793, 0],
                    [-1.255, 1.611],
                  ],
                  o: [
                    [-1.257, -1.567],
                    [-3.793, 0],
                    [0, 3.793],
                    [2.2, 0],
                    [0, 0],
                  ],
                  v: [
                    [6.08, -4.295],
                    [0.729, -6.868],
                    [-6.138, -0.001],
                    [0.729, 6.868],
                    [6.139, 4.219],
                  ],
                  c: false,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.756862804936, 0.87450986376, 0.650980392157, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 3.767 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [446.454, 152.8] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 2',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, -10.73],
                    [10.731, 0],
                    [0, 10.73],
                    [-10.73, 0],
                  ],
                  o: [
                    [0, 10.73],
                    [-10.73, 0],
                    [0, -10.73],
                    [10.731, 0],
                  ],
                  v: [
                    [19.428, 0],
                    [-0.001, 19.429],
                    [-19.429, 0],
                    [-0.001, -19.429],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 7.771 },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.964705942191, 0.956862804936, 0.917647118662, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [446.49, 152.704] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 6',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                    [-7.411, 0],
                    [0, 0],
                    [0, -7.41],
                    [0, 0],
                    [7.41, 0],
                  ],
                  o: [
                    [-7.411, 0],
                    [0, 0],
                    [0, -7.41],
                    [0, 0],
                    [7.41, 0],
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                  ],
                  v: [
                    [-38.174, 51.613],
                    [-51.613, 38.174],
                    [-51.613, -38.174],
                    [-38.174, -51.613],
                    [38.175, -51.613],
                    [51.613, -38.174],
                    [51.613, 38.174],
                    [38.175, 51.613],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.40000000596, 0.623529434204, 0.313725501299, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 4 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.964705942191, 0.956862804936, 0.917647118662, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [446.252, 165.984] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 8',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [8.462, 0],
                    [0, 0],
                    [0, 8.463],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 8.463],
                    [0, 0],
                    [-8.462, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [53.625, 13.61],
                    [53.497, 30.513],
                    [38.175, 45.835],
                    [-38.174, 45.835],
                    [-53.497, 30.513],
                    [-53.369, 13.61],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.094117654539, 0.094117654539, 0.094117654539, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [446.252, 190.68] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 9',
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 80,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Transfers',
      sr: 1,
      ks: {
        p: {
          s: true,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.45], y: [1.16] },
                o: { x: [0.333], y: [0] },
                t: 8,
                s: [190.969],
                e: [258.469],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.31], y: [-4.084] },
                t: 38,
                s: [258.469],
                e: [258.469],
              },
              { t: 65 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.37], y: [1.261] },
                o: { x: [0.333], y: [0] },
                t: 8,
                s: [85.112],
                e: [74.112],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.277], y: [1.025] },
                t: 38,
                s: [74.112],
                e: [74.112],
              },
              { t: 65 },
            ],
          },
        },
        a: { a: 0, k: [737.676, 305.397, 0] },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.333, 0.333, 0.667], y: [1.128, 1.128, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 8,
              s: [0, 0, 100],
              e: [37.64, 37.64, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.365, 0.365, 0.333], y: [-1.209, -1.209, 0] },
              t: 38,
              s: [37.64, 37.64, 100],
              e: [37.64, 37.64, 100],
            },
            { t: 51 },
          ],
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [6.509, 0],
                    [0, -6.509],
                    [-6.509, 0],
                    [0, 6.508],
                  ],
                  o: [
                    [-6.509, 0],
                    [0, 6.508],
                    [6.509, 0],
                    [0, -6.509],
                  ],
                  v: [
                    [0.001, -11.785],
                    [-11.784, 0],
                    [0.001, 11.785],
                    [11.785, 0],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [737.263, 294.531] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 10',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, -7.025],
                    [0, 0],
                  ],
                  o: [
                    [-7.024, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [6.359, -6.359],
                    [-6.36, 6.36],
                    [6.359, 6.36],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [766.247, 307.25] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 11',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [7.024, 0],
                    [0.005, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [-0.005, 0],
                    [0, 0],
                    [0, 0],
                    [0, -7.025],
                  ],
                  v: [
                    [-6.352, -6.359],
                    [-6.367, -6.358],
                    [-6.367, 6.36],
                    [6.367, 6.36],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [708.288, 307.25] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 12',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [-7.024, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 7.024],
                  ],
                  v: [
                    [6.359, 6.359],
                    [6.359, -6.359],
                    [-6.36, -6.359],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [766.247, 281.812] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 13',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 7.024],
                    [0, 0],
                    [0, 0],
                    [-0.005, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0.004, 0],
                    [7.025, 0],
                  ],
                  v: [
                    [6.367, -6.359],
                    [-6.367, -6.359],
                    [-6.367, 6.359],
                    [-6.353, 6.359],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [708.288, 281.812] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 14',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [35.343, 19.078],
                    [-35.343, 19.078],
                    [-35.343, -19.078],
                    [35.343, -19.078],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.756862804936, 0.87450986376, 0.650980392157, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [737.264, 294.531] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 15',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                    [-7.411, 0],
                    [0, 0],
                    [0, -7.411],
                    [0, 0],
                    [7.41, 0],
                  ],
                  o: [
                    [-7.411, 0],
                    [0, 0],
                    [0, -7.411],
                    [0, 0],
                    [7.41, 0],
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                  ],
                  v: [
                    [-38.173, 51.613],
                    [-51.612, 38.176],
                    [-51.612, -38.174],
                    [-38.173, -51.613],
                    [38.174, -51.613],
                    [51.612, -38.174],
                    [51.612, 38.176],
                    [38.174, 51.613],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.40000000596, 0.623529434204, 0.313725501299, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 4 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.964705942191, 0.956862804936, 0.917647118662, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [737.264, 294.53] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 17',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [8.463, 0],
                    [0, 0],
                    [0, 8.462],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 8.462],
                    [0, 0],
                    [-8.463, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [53.378, 9.624],
                    [53.497, 30.513],
                    [38.174, 45.836],
                    [-38.174, 45.836],
                    [-53.497, 30.513],
                    [-53.615, 9.624],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.094117654539, 0.094117654539, 0.094117654539, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [737.264, 323.474] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 18',
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 80,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: 'Security',
      sr: 1,
      ks: {
        p: {
          s: true,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.374], y: [1.336] },
                o: { x: [0.333], y: [0] },
                t: 11,
                s: [192.219],
                e: [235.219],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.303], y: [-2.987] },
                t: 41,
                s: [235.219],
                e: [235.219],
              },
              { t: 68 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.375], y: [1.365] },
                o: { x: [0.333], y: [0] },
                t: 11,
                s: [122.518],
                e: [140.518],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.303], y: [-2.987] },
                t: 41,
                s: [140.518],
                e: [140.518],
              },
              { t: 68 },
            ],
          },
        },
        a: { a: 0, k: [675.906, 481.822, 0] },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.333, 0.333, 0.667], y: [1.128, 1.128, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 11,
              s: [0, 0, 100],
              e: [37.64, 37.64, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.365, 0.365, 0.333], y: [-1.395, -1.395, 0] },
              t: 41,
              s: [37.64, 37.64, 100],
              e: [37.64, 37.64, 100],
            },
            { t: 56 },
          ],
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-14.874, 0.538],
                    [-5.318, 10.096],
                    [14.875, -10.096],
                  ],
                  c: false,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.964705942191, 0.956862804936, 0.917647118662, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 3.767 },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [688.059, 482.874] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 24',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [14.798, 0],
                    [-31.291, -9.245],
                  ],
                  o: [
                    [-14.798, 0],
                    [0, 0],
                    [0, 0],
                    [31.29, -9.245],
                  ],
                  v: [
                    [24.516, -19.43],
                    [0.001, -31.909],
                    [-24.514, -19.43],
                    [0.001, 31.909],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [686.594, 481.638] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 25',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                    [-7.41, 0],
                    [0, 0],
                    [0, -7.41],
                    [0, 0],
                    [7.41, 0],
                  ],
                  o: [
                    [-7.41, 0],
                    [0, 0],
                    [0, -7.41],
                    [0, 0],
                    [7.41, 0],
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                  ],
                  v: [
                    [-38.174, 51.613],
                    [-51.612, 38.175],
                    [-51.612, -38.174],
                    [-38.174, -51.613],
                    [38.175, -51.613],
                    [51.613, -38.174],
                    [51.613, 38.175],
                    [38.175, 51.613],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.40000000596, 0.623529434204, 0.313725501299, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 4 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.964705942191, 0.956862804936, 0.917647118662, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [686.595, 481.638] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 27',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 8.462],
                    [0, 0],
                    [-8.462, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-8.462, 0],
                    [0, 0],
                    [0, -8.462],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-8.96, 53.622],
                    [-30.513, 53.497],
                    [-45.836, 38.174],
                    [-45.836, -38.174],
                    [-30.513, -53.496],
                    [-8.96, -53.371],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.094117654539, 0.094117654539, 0.094117654539, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [657.652, 481.639] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 28',
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 80,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: 'Acorns',
      sr: 1,
      ks: {
        p: {
          s: true,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.306], y: [1.375] },
                o: { x: [0.333], y: [0] },
                t: 14,
                s: [108.125],
                e: [69.125],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.316], y: [5.28] },
                t: 44,
                s: [69.125],
                e: [69.125],
              },
              { t: 71 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.425], y: [1.629] },
                o: { x: [0.333], y: [0] },
                t: 14,
                s: [123.018],
                e: [140.518],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.341], y: [-5.186] },
                t: 44,
                s: [140.518],
                e: [140.518],
              },
              { t: 71 },
            ],
          },
        },
        a: { a: 0, k: [234.634, 481.822, 0] },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.333, 0.333, 0.667], y: [1.128, 1.128, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 14,
              s: [0, 0, 100],
              e: [37.64, 37.64, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.365, 0.365, 0.333], y: [-1.395, -1.395, 0] },
              t: 44,
              s: [37.64, 37.64, 100],
              e: [37.64, 37.64, 100],
            },
            { t: 59 },
          ],
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [20.963, -4.023],
                    [0.575, 0.009],
                    [0.951, 0.811],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-0.951, 0.811],
                    [-0.575, 0.009],
                    [-21.081, -3.613],
                    [0, 0],
                  ],
                  v: [
                    [20.704, -13.998],
                    [3.164, 11.328],
                    [0.059, 13.99],
                    [-3.046, 11.328],
                    [-20.588, -13.998],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [225.495, 496.51] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 19',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [3.787, -0.297],
                    [0, 0],
                    [-22.152, 1.595],
                    [-0.122, 0.402],
                    [-0.02, 0.687],
                    [0.251, 0.699],
                    [0.448, 0.526],
                    [-0.654, -0.269],
                    [-0.767, -0.764],
                    [-0.588, -0.991],
                    [-0.24, -0.519],
                    [-0.104, -0.273],
                  ],
                  o: [
                    [0, 0],
                    [-3.816, -0.298],
                    [0.21, -0.098],
                    [0.206, -0.744],
                    [0.023, -0.84],
                    [-0.227, -0.62],
                    [0.683, 0],
                    [0.84, 0.336],
                    [0.712, 0.702],
                    [0.28, 0.475],
                    [0.114, 0.251],
                    [21.622, 1.866],
                  ],
                  v: [
                    [21.661, 13.591],
                    [-21.632, 13.595],
                    [-3.173, -6.891],
                    [-2.795, -7.414],
                    [-2.451, -9.572],
                    [-2.791, -11.858],
                    [-3.809, -13.595],
                    [-1.797, -13.19],
                    [0.661, -11.513],
                    [2.618, -8.962],
                    [3.392, -7.488],
                    [3.72, -6.703],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [225.557, 466.96] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 20',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                    [-7.41, 0],
                    [0, 0],
                    [0, -7.41],
                    [0, 0],
                    [7.41, 0],
                  ],
                  o: [
                    [-7.41, 0],
                    [0, 0],
                    [0, -7.41],
                    [0, 0],
                    [7.41, 0],
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                  ],
                  v: [
                    [-38.174, 51.613],
                    [-51.613, 38.175],
                    [-51.613, -38.174],
                    [-38.174, -51.613],
                    [38.174, -51.613],
                    [51.613, -38.174],
                    [51.613, 38.175],
                    [38.174, 51.613],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.40000000596, 0.623529434204, 0.313725501299, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 4 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.964705942191, 0.956862804936, 0.917647118662, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [222.936, 481.638] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 22',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, -8.462],
                    [0, 0],
                    [8.462, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [8.462, 0],
                    [0, 0],
                    [0, 8.462],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [8.96, -53.371],
                    [30.514, -53.496],
                    [45.835, -38.174],
                    [45.835, 38.175],
                    [30.514, 53.496],
                    [8.96, 53.622],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.094117654539, 0.094117654539, 0.094117654539, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [251.878, 481.638] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 23',
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 80,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: 'LinkedAccounts',
      sr: 1,
      ks: {
        p: {
          s: true,
          x: {
            a: 1,
            k: [
              {
                i: { x: [0.095], y: [1.071] },
                o: { x: [0.333], y: [0] },
                t: 17,
                s: [105.344],
                e: [45.344],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.387], y: [1.874] },
                t: 47,
                s: [45.344],
                e: [45.344],
              },
              { t: 74 },
            ],
          },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0.048], y: [1.377] },
                o: { x: [0.333], y: [0] },
                t: 17,
                s: [85.049],
                e: [74.049],
              },
              {
                i: { x: [0.667], y: [1] },
                o: { x: [0.353], y: [1.86] },
                t: 47,
                s: [74.049],
                e: [74.049],
              },
              { t: 74 },
            ],
          },
        },
        a: { a: 0, k: [171.453, 305.231, 0] },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.333, 0.333, 0.667], y: [1.128, 1.128, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 17,
              s: [0, 0, 100],
              e: [37.64, 37.64, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.365, 0.365, 0.333], y: [-1.209, -1.209, 0] },
              t: 47,
              s: [37.64, 37.64, 100],
              e: [37.64, 37.64, 100],
            },
            { t: 60 },
          ],
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [4.26, 4.26],
                    [-4.26, 4.26],
                    [0, 0],
                    [-3.077, -0.23],
                  ],
                  o: [
                    [0, 0],
                    [-4.259, 4.26],
                    [-4.26, -4.26],
                    [0, 0],
                    [2.34, -2.34],
                    [0, 0],
                  ],
                  v: [
                    [17.051, 0.136],
                    [2.699, 14.488],
                    [-12.791, 14.488],
                    [-12.791, -1.003],
                    [1.56, -15.354],
                    [10.134, -18.518],
                  ],
                  c: false,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.756862804936, 0.87450986376, 0.650980392157, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 3.767 },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [173.926, 319.15] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 29',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [4.26, 4.26],
                    [0, 0],
                    [-4.26, 4.26],
                    [0, 0],
                    [-4.259, -4.26],
                    [4.261, -4.259],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-4.26, -4.26],
                    [0, 0],
                    [4.26, -4.26],
                    [4.261, 4.26],
                    [0, 0],
                    [-4.26, 4.26],
                  ],
                  v: [
                    [-14.921, 14.921],
                    [-14.921, 14.921],
                    [-14.921, -0.569],
                    [-0.57, -14.921],
                    [14.921, -14.921],
                    [14.921, 0.569],
                    [0.57, 14.921],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.454901990704, 0.788235353956, 0.282352941176, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 3.767 },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [189.757, 291.315] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 30',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-4.26, -4.26],
                    [4.259, -4.26],
                  ],
                  o: [
                    [4.26, -4.26],
                    [4.259, 4.26],
                    [0, 0],
                  ],
                  v: [
                    [-9.875, -5.615],
                    [5.616, -5.615],
                    [5.616, 9.875],
                  ],
                  c: false,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.756862804936, 0.87450986376, 0.650980392157, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 3.767 },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [185.362, 309.41] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 31',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                    [-7.411, 0],
                    [0, 0],
                    [0, -7.411],
                    [0, 0],
                    [7.411, 0],
                  ],
                  o: [
                    [-7.411, 0],
                    [0, 0],
                    [0, -7.411],
                    [0, 0],
                    [7.411, 0],
                    [0, 0],
                    [0, 7.41],
                    [0, 0],
                  ],
                  v: [
                    [-38.174, 51.613],
                    [-51.613, 38.176],
                    [-51.613, -38.173],
                    [-38.174, -51.613],
                    [38.174, -51.613],
                    [51.614, -38.173],
                    [51.614, 38.176],
                    [38.174, 51.613],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [0.40000000596, 0.623529434204, 0.313725501299, 1] },
              o: { a: 0, k: 100 },
              w: { a: 0, k: 4 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.964705942191, 0.956862804936, 0.917647118662, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [182.907, 305.171] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 33',
          bm: 0,
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 8.462],
                    [0, 0],
                    [-8.463, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-8.463, 0],
                    [0, 0],
                    [0, -8.462],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [45.835, 53.497],
                    [-30.513, 53.497],
                    [-45.836, 38.175],
                    [-45.836, -38.174],
                    [-30.513, -53.497],
                    [45.835, -53.497],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0.094117654539, 0.094117654539, 0.094117654539, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [153.964, 305.171] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Group 34',
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 80,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 2,
      nm: 'BankLinking_Phone.png',
      cl: 'png',
      refId: 'image_0',
      sr: 1,
      ks: {
        p: {
          s: true,
          x: { a: 0, k: 150 },
          y: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.08], y: [0.828] },
                t: 0,
                s: [334.875],
                e: [112],
              },
              { t: 40 },
            ],
          },
        },
        a: { a: 0, k: [1111, 1941, 0] },
        s: { a: 0, k: [3.85, 3.85, 100] },
      },
      ao: 0,
      ip: 0,
      op: 80,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
}
